import React, { useMemo } from "react";
import { convertIntegerToMoney } from "../../../modules/helpers";
import "../../styles/components/resultCard.scss";
import { R$ } from "../../utils/brl";
import { NumberBichoGroup } from "../../../rifa/components/layout/numberBichoGroup";
import {X} from "phosphor-react";

/**
 *
 * @param {{
 *  cart: {
 *      number: number,
 *      amount: number,
 *      value: number
 *  }[]
 * numbers: number[]
 * title: string
 * index: string | number
 * premio: string
 * valorCada: number
 * valorTotal: total
 * isBallType: boolean
 * tipoJogo: Record<string, any>,
 * chrSeparador: string
 * teams: {
 *  nome: string,
 *  vchURLImagem: string,
 * arrNumeros: number[],
 * isBicho: boolean,
* earned: boolean,
* earnedFromQuota: boolean,
 * }
 * }} props
 */
export default function ResultCard({
  cart,
  title,
  index,
  premio,
  numbers,
  valorTotal,
  isBallType = false,
  teams,
  numberLength = 4,
  tipoJogo = {},
  isBicho,
  earned = false,
  earnedFromQuota = false
}) {
  const chrSeparador = tipoJogo.chrSeparador;

  const valorDaAposta = useMemo(() => {
    if (!!cart) {
      return convertIntegerToMoney(
        cart.reduce((sum, item) => {
          return (item.value * (item.amount || 1)) + sum
        }, 0) * 100
      );
    }

    return valorTotal || null;
  }, [cart, valorTotal]);
  
  const isGroup = typeof isBicho != 'undefined' ? isBicho : (!!tipoJogo.tnyTamanhoMax && !!tipoJogo.tnyNumeroMin && tipoJogo.tnyNumeroMax === 25 && tipoJogo.tnyNumeroMin === 1);
  const isCombined = !!tipoJogo.tnyTamanhoMax && !!tipoJogo.tnyTamanhoMin && (tipoJogo.tnyTamanhoMax != tipoJogo.tnyTamanhoMin);

  return (
    <React.Fragment>
      <div className="result_card__container">
        {index && <aside>{index}</aside>}
        <div className="result_card__content">
          <div className="result_card__title">
            <span>{title}</span>
          </div>
          <div className={`result_card__list ${!!teams ? "isSupertime" : ""}`}>
          {cart && (isGroup 
            ? <NumberBichoGroup hideCorrespondantNumbers numbers={cart.map(item => item.number)} separatorChar={chrSeparador} separatorElement={<X weight="bold" color="var(--primary)"/>} cart={cart}/>
            : cart.sort((a, b) => a.number - b.number).map((item) => {
              const earnedInGame = (item.jogo && item.jogo.numPremio && item.jogo.numPremio > 0) || (item.jogo && item.jogo.numValorPremioCota && item.jogo.numValorPremioCota > 0);
              const earnedInGameFromQuota = (item.jogo && item.jogo.numValorPremioCota && item.jogo.numValorPremioCota > 0);

              return (
              <div key={item.number} className={`result_card__item ${(earned || earnedInGame) ? "earnedPrize" : ""} ${(earnedInGameFromQuota || earnedFromQuota) ? "earnedQuotaPrize" : ""}`}>
                {String(item.number).padStart(numberLength, 0)}
                {item.amount > 1 && (
                  <div className="result_card__item_amount">
                    x{item.amount}
                  </div>
                )}
              </div>
          )}))}
          { numbers && (numbers.length &&
              isGroup ?
                isCombined
                  ? <NumberBichoGroup isCombined={isCombined} hideCorrespondantNumbers
                    numbers={numbers}
                    separatorChar={chrSeparador}
                    separatorElement={<X weight="bold" color="var(--primary)"/>}
                  />
                  : <NumberBichoGroup hideCorrespondantNumbers numbers={numbers} separatorChar={chrSeparador} separatorElement={<X weight="bold" color="var(--primary)"/>}/>
              : numbers.sort((a, b) => a - b).map((number, i) => (
                  <React.Fragment>
                    {isBallType ? (
                      <div key={number} className="result_card__ball_item">
                        {number}
                      </div>
                    ) : (
                      <div key={number} className={!index?"result_card__item_alternative":`result_card__item ${earned ? "earnedPrize" : ""} ${earnedFromQuota ? "earnedQuotaPrize" : ""}`}>
                        {!index && <aside>{`${i+1}° `}</aside>} {isGroup ? number.toString().slice(-2) : number}
                      </div>
                    )}
                  </React.Fragment>
                )))}
            {teams &&
              teams.map((team) => (
                <div key={team.nome} className="result_card__supertime">
                  {team.vchURLImagem && <img src={team.vchURLImagem} />}
                  <span className="result_card__supertime_name">
                    {team.nome}
                  </span>
                  <span className="result_card__supertime_name">
                    {team.arrNumeros[0] !== "00"
                      ? team.arrNumeros[0].toString().padStart(2, "0")
                      : ""}
                  </span>
                </div>
              ))}
          </div>
          <div className="result_card__footer">
            <span>
              {!!valorDaAposta && (
                <React.Fragment>
                  <strong>Valor de aposta: </strong>R$ {valorDaAposta}
                </React.Fragment>
              )}
            </span>
            <span>
              {!!premio && (
                <React.Fragment>
                  <strong>Prêmio(s): </strong>
                  {R$(premio)}
                </React.Fragment>
              )}
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/rifa/components/layout/resultCard.jsx